import React from 'react'
import { Card, makeStyles, Typography } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { usePlace } from 'commons/usePlace'
import Assets from 'app/configs/assetConfigs'
import ImageWithFallback from 'app/components/ImageWithFallback'
import clsx from 'clsx'
import * as R from 'ramda'
import RichTextDisplay from 'app/components/richTextEditor/RichTextDisplay'
import { useDefaultLanguage } from 'commons/useDefaultLanguage'
import { DATE_FORMAT_VOUCHER } from 'libs/dateUtils'
import moment from 'moment'

const useStyles = makeStyles((theme) => ({
  previewStyle: {
    borderRadius: 0,
    margin: '1rem',
    color: '#404040',
  },
  placeName: {
    color: theme.palette.secondary.main,
    margin: 'auto',
    marginLeft: 0,
  },
  placeLogoImage: {
    objectFit: 'cover',
    objectPosition: 'center',
    overflow: 'hidden',
    borderRadius: '50%',
    padding: '20px',
  },
  directionRtl: {
    direction: 'rtl',
  },
  textColorBlur: {
    fontSize: '12px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    color: '#247bcd',
  },
  dotColor: {
    color: '#00314b',
  },
  descriptionStyle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    paddingLeft: '40px',
    paddingRight: '40px',
    wordBreak: 'break-all',
    overflow: 'hidden',
    maxHeight: '430px',
  },
  authoredText: {
    fontSize: '10px',
  },
}))

export const viewLogo = R.view(R.lensPath(['info', 'logo']))
export const viewName = R.view(R.lensPath(['name']))

const PreviewVoucherCard = ({
  vouchers,
  isVoucherViewerLoading,
  templateView,
}) => {
  const classes = useStyles()
  const place = usePlace()
  const language = useDefaultLanguage()

  const showValidFromDate = ({ startDate, endDate }) => {
    let dateFormat = `${moment(startDate).format(
      DATE_FORMAT_VOUCHER,
    )} - ${moment(endDate).format(DATE_FORMAT_VOUCHER)}`

    if (R.equals(moment(startDate).format('M'), moment(endDate).format('M'))) {
      dateFormat = `${moment(startDate).format('MMMM')} ${moment(
        startDate,
      ).format('DD')} - ${moment(endDate).format('DD')} , ${moment(
        endDate,
      ).format('YYYY')}`
    }
    return dateFormat
  }

  if (vouchers && !isVoucherViewerLoading) {
    return (
      <Card
        className={clsx(classes.previewStyle, 'w-11/12 sm:w-md')}
        elevation={5}
      >
        <div className="w-full flex justify-start">
          <ImageWithFallback
            className={clsx(classes.placeLogoImage, 'w-3/12 h-full')}
            alt="logo"
            src={viewLogo(place)}
            fallbackSrc={Assets.defaultPlaceImage}
          />

          <Typography className={clsx(classes.placeName, 'truncate ')}>
            <b>{viewName(place)}</b>
          </Typography>
        </div>
        <div className="w-full relative text-center">
          <RichTextDisplay text={templateView} />
        </div>
        <div className="w-full p-5">
          <div className="font-bold text-xl">
            <RichTextDisplay text={R.prop('title', vouchers)} />
          </div>
          <RichTextDisplay text={R.prop('body', vouchers)} />
        </div>
        <div className="w-full p-5">
          <Typography className="font-bold text-xs">
            <FormattedMessage id="preview.voucher.valid.label" />
          </Typography>
          <Typography className="text-xs">
            {showValidFromDate({
              startDate: R.path(['voucher', 'startDateTime'], vouchers),
              endDate: R.path(['voucher', 'endDateTime'], vouchers),
            })}
          </Typography>
        </div>
        <Typography
          className={clsx('w-full p-5  text-gray-400', classes.authoredText)}
        >
          <FormattedMessage
            id="preview.voucher.authored"
            values={{ language: R.prop('name', language) }}
          />
        </Typography>
      </Card>
    )
  } else return null
}

export default PreviewVoucherCard
